<template>


<m-mobile-autocomplete
    :value="internal_value"
    :items="items"
    :search="doSearch"
    v-on:input="onInput"
    :label="label"
    placeholder="Search RedChirp users"
/>

</template>

<script>
const E164 = require('@/js/E164.js');
const device = require('@/js/device.js');

export default {
    props: {
        value: {
            type: [String, Object],
            default: function() { return null; },
        },
        
        label: {
            type: String,
            default: function() { return "Name"; },
        },

        organization_id: {
            type: String,
            default: function() { return null; },
        },

        autofocus: {
            type: Boolean,
            default: function() { return false; },
        },

        'return-object' : {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            internal_value: null,
            items: [],
            search: null,
            is_loading: false, 
        }
    },

    mounted () 
    {
        if ( this.value != null && typeof this.value === 'string' )
        {
            this.setValueFromString(this.value);
            this.internal_value = null;
        }
        else
        {
            this.internal_value = this.value;
        }

        if ( this.value == null )
            this.doSearch('');
    },

    methods: {
        onInput(val) {

            if ( val == null )
            {
                this.$emit('input', null);
                this.internal_value = null;
                this.search = null;
                return;
            }

            if ( this['return-object'] )
            {
                this.$emit('input', val);
            }
            else
            {
                this.$emit('input', val.value);
            }

            this.internal_value = val;
        },

        passAllItems(item, queryText, itemText)
        {
            return true;
        },

        doSearch(val)
        {
            this.is_loading = true;

            let full_text_search = val;
            if ( val != null && val.indexOf("(") != -1 )
            {
                full_text_search = val.substring(0,val.indexOf("("));
            }

            let search = {
                'organization_id': this.organization_id,
                'full_text' : full_text_search,
            };

            this.$rc.searchEmployeeLabels(

                search,

                (data) => {
                    this.is_loading = false;

                    this.items = data.results;

                    for ( let i = 0; i < this.items.length; i++ )
                    {
                        this.items[i].text = this.items[i].employee_label;
                        this.items[i].value = this.items[i].employee_id;
                    }
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }
            );
        },

        autocompleteMenuProps() {
            return device.autocompleteMenuProps();
        },

        setValueFromString(val)
        {
            if ( val == null ) return;
            if ( typeof val !== 'string' ) return;

            // assume the type is an employee id...
            
            this.is_loading = true;

            let search = {
                'organization_id': this.organization_id,
                'employee_id' : val,
            };

            this.$rc.searchEmployeeLabels(

                search,

                (data) => {
                    this.is_loading = false;

                    this.items = data.results;


                    for ( let i = 0; i < this.items.length; i++ )
                    {
                        this.items[i].text = this.items[i].employee_label;
                        this.items[i].value = this.items[i].employee_id;
                    }

                    if ( this.items.length == 0 )
                    {
                        this.internal_value = null;
                        this.search = null;
                        return;
                    }
                    else
                    {
                        this.internal_value = this.items[0];
                        this.search = this.items[0].text;
                    }
                },

                () => {
                    this.is_loading = false;
                    this.items = [];
                }

            );
        },
    },

    watch: {
        value(val) {

            if ( val == null )
            {
                this.items = null;
                this.internal_value = null;
                this.search = null;
                return;
            }

            else if ( typeof val === 'string' )
            {
                this.setValueFromString(val);
            }

            else 
            {
                this.items=[val];
                this.internal_value = this.items[0];
                this.search = this.internal_value.text;
            }
        },

        search(val) {
            this.doSearch(val);
        }
    },
}

</script>

<style lang="scss" scoped>

</style>